import { ReactElement } from 'react';
import { Button, makeStyles, Box } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { SparklesIcon } from '../../icons/sparkles-icon';

const useStyles = makeStyles<Theme>(theme => ({
  button: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    padding: theme.spacing(1, 2),
    minWidth: '190px', // Fixed min-width to prevent layout shift
    height: '36px', // Fixed height for consistency
    marginTop: '10px', // Move button down 10px for better alignment
    color:
      theme.palette.type === 'dark' ? '#B3DCF3' : theme.palette.primary.dark,
    border: `1px solid ${
      theme.palette.type === 'dark' ? '#B3DCF3' : theme.palette.primary.dark
    }`,
    backgroundColor: 'transparent',
    borderRadius: '20px', // More rounded corners
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(227, 245, 253, 0.08)'
          : 'rgba(227, 245, 253, 0.4)',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    marginLeft: 'auto', // Push button to the right
    flexShrink: 0, // Prevent button from shrinking
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: '4px',
  },
}));

export interface AutoRemediationButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const AutoRemediationButton = ({
  isExpanded,
  onClick,
}: AutoRemediationButtonProps): ReactElement => {
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      onClick={onClick}
      aria-expanded={isExpanded}
      aria-label={
        isExpanded ? 'Collapse auto remediation' : 'Expand auto remediation'
      }
    >
      <Box className={classes.iconWrapper}>
        <SparklesIcon color="currentColor" size={16} />
      </Box>
      Auto remediation
      {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </Button>
  );
};
